import classNames from "classnames";
import { Suspense, lazy, useEffect, useState } from "react";
import Icon from "./icon";
import PickUpPointsCard from "./pick-up-point-card";

const Map = lazy(() => import("./cart/map"));

const ChoicePoints = ({ labels, pickUpPoints, selected, setSelected, clinic = false }) => {
  const [mobileView, setMobileView] = useState("list");

  const handleSelection = (e) => {
    const currentId = e.currentTarget?.id;
    if (currentId) {
      setSelected((current) => (current === currentId ? null : e.currentTarget.id));
    }
  };

  useEffect(() => {
    const selectedElem = document.getElementById(`scroll-ref-${selected}`);
    if (selectedElem) {
      selectedElem.scrollIntoView({ behavior: "smooth" });
    }
  }, [selected]);

  return (
    <div className={classNames("pick-up-points", mobileView)}>
      <div className="pick-up-points__menu">
        <button
          id="list"
          className={classNames("pick-up-points__menu-item", mobileView === "list" && "active")}
          onClick={() => setMobileView("list")}
        >
          {labels?.WELFARE_LIST || "List"}
        </button>
        <button
          className={classNames("pick-up-points__menu-item", mobileView === "map" && "active")}
          onClick={() => setMobileView("map")}
        >
          {labels?.WELFARE_MAP || "Map"}
        </button>
      </div>
      <div className="pick-up-points__wrapper">
        <div className="pick-up-points__list-wrapper">
          {pickUpPoints?.some((point) =>
            clinic ? point?.notProvidedExams?.length === 0 : true
          ) && (
            <div className="pick-up-points__list">
              {pickUpPoints
                ?.filter((point) => (clinic ? point?.notProvidedExams?.length === 0 : true))
                ?.map((point) => (
                  <div
                    className={classNames(
                      "pick-up-points__point",
                      Number(selected) === point?.id && "pick-up-points__point--selected"
                    )}
                    id={point?.id}
                    onClick={handleSelection}
                    key={point?.id}
                  >
                    <span className="pick-up-points__scroll-ref" id={`scroll-ref-${point?.id}`} />
                    <PickUpPointsCard point={point} clinic={clinic} labels={labels} />
                  </div>
                ))}
            </div>
          )}
          {clinic && pickUpPoints?.some((point) => point?.notProvidedExams?.length > 0) && (
            <div className="pick-up-points__list">
              <div className="error-box">
                <Icon name="error" />
                <div
                  className="error-box__text"
                  dangerouslySetInnerHTML={{
                    __html:
                      labels?.WELFARE_CHECKUP_CLINICS_WARNING ||
                      "<p>Nei seguenti centri non è possibile svolgere alcune delle visite che hai selezionato</p>",
                  }}
                />
              </div>
              {pickUpPoints
                ?.filter((point) => point?.notProvidedExams?.length > 0)
                ?.map((point) => (
                  <div
                    className={classNames(
                      "pick-up-points__point",
                      Number(selected) === point?.id && "pick-up-points__point--selected"
                    )}
                    id={point?.id}
                    onClick={handleSelection}
                    key={point?.id}
                  >
                    <span className="pick-up-points__scroll-ref" id={`scroll-ref-${point?.id}`} />
                    <PickUpPointsCard point={point} clinic={clinic} labels={labels} />
                  </div>
                ))}
            </div>
          )}
        </div>
        <div className="pick-up-points__map">
          <Suspense fallback={<div className="loading-spinner" />}>
            <Map
              markers={pickUpPoints}
              selected={selected}
              setSelected={setSelected}
              labels={labels}
            />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default ChoicePoints;
